module.exports = __webpack_public_path__ + "static/media/hall-P10.3f2bdeb2.svg";